const Backgrounds = [
	{
		'id': 'capitol',
		'type': 'image',
		'image': 'campaigns/capitol-building',
		'gravity': 'north'
	},
	{
		'id': '114th-congress',
		'type': 'image',
		'image': 'campaigns/114th-congress',
		'gravity': 'center'
	},
	{
		'id': 'voting-booths',
		'type': 'image',
		'image': 'campaigns/voting-booths',
		'gravity': 'center'
	},
	{
		'id': 'us-map',
		'type': 'image',
		'image': 'campaigns/us-map',
		'gravity': 'center'
	}
]

export default Backgrounds;


// WEBPACK FOOTER //
// ./src/data/Backgrounds.js